import React, { useState } from 'react';

const VectorSearch = () => {
    const [query, setQuery] = useState('');
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleSearch = async () => {
        setLoading(true);
        const response = await fetch('/api/ai/vector-search', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ query }),
        });
        const data = await response.json();
        setResults(data.results);
        setLoading(false);
    };

    return (
        <div>
            <h2 className="text-xl font-bold mb-4">Vector Search</h2>
            <div className="flex">
                <input
                    type="text"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    className="w-full border border-gray-300 rounded-md px-3 py-2"
                    placeholder="Search for documents..."
                />
                <button
                    onClick={handleSearch}
                    className="ml-2 bg-blue-600 text-white px-4 py-2 rounded-lg"
                    disabled={loading}
                >
                    {loading ? 'Searching...' : 'Search'}
                </button>
            </div>
            <div className="mt-4">
                {results.map((result: any) => (
                    <div key={result.id} className="border-b py-2">
                        <h3 className="font-bold">{result.metadata.title}</h3>
                        <p>{result.content_text}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default VectorSearch;
